import React from 'react';
export const Promo = ({ children }) => React.createElement("div", { className: "text-center" }, children);
Promo.Title = ({ children }) => React.createElement("span", { className: "text-lg leading-6 text-black block" }, children);
Promo.Description = ({ children }) => (React.createElement("span", { className: "leading-7 text-sm text-grey-60 block" }, children));
Promo.Actions = ({ children }) => React.createElement("div", { className: "my-6" }, children);
Promo.Image = (props) => React.createElement("img", { alt: "", className: "mx-auto mb-5", ...props });
